import PropTypes from 'prop-types';
import React from 'react';

import { ChevronDownIcon } from 'lucide-react';
import moment from 'moment';
import { FormSectionCollapsible, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, Row, Col, Badge } from 'twyne-new.ui';

import Funnel from './Funnel';
import Table from './Table';
import { numberFormat, getUniqueImpressionsCount, formatPath } from './formatters';

const propTypes = {
  item: PropTypes.object,
  progressionType: PropTypes.string
};

class ProgressionBody extends React.Component {
  state = {
    progressionType: 'Completed',
  }

  get unique() {
    return getUniqueImpressionsCount(this.props.item)
  }

  CardTitle = () => {
    const avg = this.avgCompletionTime()
    return <div className='flex items-center'>
      <span className='text-md'>{formatPath(this.props.item)}</span>
      <span className='mx-1'>-</span>
      <span className='text-sm twy-text-base'>{numberFormat(this.props.item.total)} total impressions {avg}</span>
    </div>
  }

  avgCompletionTime(){
    let avgText = ''
    if (this.props.item.timeAvg > 0){
      const avgFormated = this.formatMs(this.props.item.timeAvg)
      avgText = `| total average completion time: ${avgFormated}`
    }
    return avgText
  }

  formatMs(ms){
    const duration = moment.duration(ms)
    const avgFormated = moment.utc(duration.as('milliseconds')).format('HH:mm:ss')
    return avgFormated
  }

  ProgressionType = () => <>
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Badge color='accent' size='lg' variant='light'>
          {this.state.progressionType}
          <ChevronDownIcon size={12} />
        </Badge>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {['Impressions', 'Completed'].map((option, index) => <>
          <DropdownMenuItem
            onClick={() => this.setState({ progressionType: option })}
            key={index}
          >
            {option}
          </DropdownMenuItem>
        </>)}
      </DropdownMenuContent>
    </DropdownMenu>
  </>

  Header = () => <div className='w-full flex justify-between items-center'>
    <this.CardTitle />
    <this.ProgressionType />
  </div>

  render() {
    return <>
      <FormSectionCollapsible
        defaultOpen
        border
        triggerClass='py-2 px-4 twy-subtle-neutral'
        contentClass='p-4 overflow-visible'
        titleClass='text-base pr-2'
        sectionClass='w-full overflow-visible'
        title={<this.Header />}
      >
        <Row>
          <Col size="9">
            <Table
              slots={this.props.item.children}
              id={this.props.item.id}
            />
          </Col>
          <Col size="3" className='pt-[41px]'>
            <Funnel
              item={this.props.item}
              progressionType={this.state.progressionType}
            />
          </Col>
        </Row>
      </FormSectionCollapsible>
    </>
  }
}

ProgressionBody.propTypes = propTypes;

export default ProgressionBody;
